// src/components/pos/PosReturns.jsx
import React, { useState } from 'react';
import { notify } from '../../Shared/toast';

function PosReturns() {
  // Mock returns data
  const [returns, setReturns] = useState([
    {
      id: 'R001',
      date: '2025-08-10 14:35',
      product: 'Burger',
      quantity: 2,
      reason: 'Wrong item',
      status: 'Pending',
    },
    {
      id: 'R002',
      date: '2025-08-11 12:15',
      product: 'Coke',
      quantity: 1,
      reason: 'Damaged bottle',
      status: 'Completed',
    },
    {
      id: 'R003',
      date: '2025-08-12 16:50',
      product: 'Pizza',
      quantity: 1,
      reason: 'Late delivery',
      status: 'Pending',
    },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  // Handle status change for mock data
  const markAsCompleted = (id) => {
    setReturns((prev) => prev.map((item) => (item.id === id ? { ...item, status: 'Completed' } : item)));
    notify.success(`Return ${id} marked as completed!`);
  };

  // Filtered and searched data
  const filteredReturns = returns.filter((r) => {
    const matchesSearch = r.id.toLowerCase().includes(searchTerm.toLowerCase())
      || r.product.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === '' || r.status === filterStatus;
    return matchesSearch && matchesStatus;
  });

  return (
    <div className="bg-white p-4 rounded-lg shadow">
      <h2 className="text-xl font-bold mb-4">POS Returns</h2>

      {/* Search & Filters */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <input
          type="text"
          placeholder="Search by ID or product..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="p-2 border rounded w-full"
        />
        <select
          value={filterStatus}
          onChange={(e) => setFilterStatus(e.target.value)}
          className="p-2 border rounded w-full"
        >
          <option value="">All Status</option>
          <option value="Pending">Pending</option>
          <option value="Completed">Completed</option>
        </select>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border">
          <thead>
            <tr className="bg-gray-100 text-left">
              <th className="py-2 px-4 border-b">Return ID</th>
              <th className="py-2 px-4 border-b">Date</th>
              <th className="py-2 px-4 border-b">Product</th>
              <th className="py-2 px-4 border-b">Qty</th>
              <th className="py-2 px-4 border-b">Reason</th>
              <th className="py-2 px-4 border-b">Status</th>
              <th className="py-2 px-4 border-b">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredReturns.length > 0 ? (
              filteredReturns.map((item) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="py-2 px-4 border-b">{item.id}</td>
                  <td className="py-2 px-4 border-b">{item.date}</td>
                  <td className="py-2 px-4 border-b">{item.product}</td>
                  <td className="py-2 px-4 border-b">{item.quantity}</td>
                  <td className="py-2 px-4 border-b">{item.reason}</td>
                  <td
                    className={`py-2 px-4 border-b font-semibold ${
                      item.status === 'Pending'
                        ? 'text-yellow-600'
                        : 'text-green-600'
                    }`}
                  >
                    {item.status}
                  </td>
                  <td className="py-2 px-4 border-b">
                    {item.status === 'Pending' && (
                      <button
                        type="button"
                        onClick={() => markAsCompleted(item.id)}
                        className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                      >
                        Mark Completed
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="7"
                  className="text-center py-4 text-gray-500"
                >
                  No returns found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PosReturns;
